import React from 'react';
import useCompanyLocations from '../../locations/hooks/useCompanyLocations';
import './TeamLabelLocationFilter.css';

const TeamLabelLocationFilter = ({
  companyId,
  companyData,
  value,
  onChange,
}) => {
  const { activeLocations, loading } = useCompanyLocations({
    companyId,
    companyData,
    activeOnly: true,
  });

  if (loading || activeLocations.length <= 1) {
    return null;
  }

  return (
    <label className="team-cal-location-filter">
      <span className="team-cal-location-filter__label">Location</span>
      <select
        className="team-cal-location-filter__select"
        value={value || 'all'}
        onChange={(event) => {
          const nextValue = event.target.value;
          onChange?.(nextValue === 'all' ? null : nextValue);
        }}
      >
        <option value="all">All locations</option>
        {activeLocations.map((location) => (
          <option key={location.id} value={location.id}>
            {location.name}
          </option>
        ))}
      </select>
    </label>
  );
};

export default TeamLabelLocationFilter;
